// import React, { useState, useEffect } from "react";
// import { useParams } from "react-router-dom";
// import axiosInstance from "../../utils/axiosUtil";
// import { getError } from "../../utils/error";
// import LoadingBox from "../layout/LoadingBox";
// import MessageBox from "../layout/MessageBox";

// const SampleRequestDetail = () => {
//   const { id } = useParams();

//   const [reportDetail, setReportDetail] = useState({});
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [message, setMessage] = useState("");

//   useEffect(() => {
//     fetchContacts();
//   }, []);

//   const fetchContacts = async () => {
//     try {
//       setLoading(true);
//       setError("");

//       const response = await axiosInstance.get(`/sample-requests/detail/${id}`);

//       setReportDetail(response.data);
//     } catch (err) {
//       setError(getError(err));
//       console.error("Error fetching report detail in sample requests:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return <div>SampleRequestDetail</div>;
// };



import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import axiosInstance from "../../utils/axiosUtil";
import { getError } from "../../utils/error";
import LoadingBox from "../layout/LoadingBox";
import MessageBox from "../layout/MessageBox";

const SampleRequestDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [reportDetail, setReportDetail] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchDetail = async () => {
      try {
        setLoading(true);
        const { data } = await axiosInstance.get(`/sample-requests/detail/${id}`);
        setReportDetail(data);
      } catch (err) {
        setError(getError(err));
      } finally {
        setLoading(false);
      }
    };
    fetchDetail();
  }, [id]);

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  if (loading) return <div className="loader"><LoadingBox /></div>;
  if (error) return <Container className="py-4"><MessageBox variant="danger">{error}</MessageBox></Container>;

  return (<>
    <style>{`
  .loader{color:blue; padding-top:20px; padding-bottom:20px}
        .page-section { background-color: #f8f9fa; min-height: 100vh; }
        .page-title { font-weight: 700; color: #1a202c; }
        .detail-card { border: none; border-radius: 8px; box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075); }
        .detail-grid { display: flex; flex-wrap: wrap; gap: 20px; }
        .detail-item { flex: 1 1 calc(50% - 20px); border-bottom: 1px solid #f0f0f0; padding-bottom: 10px; }
        .detail-item label { display: block; font-size: 0.75rem; text-transform: uppercase; color: #6c757d; font-weight: 700; margin-bottom: 4px; letter-spacing: 0.5px; }
        .detail-item p { font-size: 0.95rem; color: #2d3748; margin-bottom: 0; font-weight: 500; }
        .requirement-box { background: #ffffff; border: 1px solid #e2e8f0; padding: 15px; border-radius: 6px; white-space: pre-wrap; line-height: 1.6; color: #4a5568; }
        .meta-label { color: #6c757d; font-size: 0.8rem; display: block; }
        
        @media (max-width: 768px) {
            .detail-item { flex: 1 1 100%; }
        }
      `}</style>
    <Container fluid className="page-section py-4">
      <Row className="mb-4 align-items-center">
        <Col>
          <button className="btn btn-outline-primary btn-sm mb-2" onClick={() => navigate(-1)}>
            &larr; Back to List
          </button>
          <h3 className="page-title">Request Details</h3>
          <p className="page-subtitle mb-0 text-muted">Detailed view of the sample request from {reportDetail.name}</p>
        </Col>
      </Row>

      <Row>
        <Col lg={6}>
          {/* User Information Card */}
          <Card className="shadow-sm mb-4">
            <Card.Header className="bg-white py-3">
              <h5 className="mb-0 text-primary">Contact Information</h5>
            </Card.Header>
            <Card.Body>
              <div className="detail-grid">
                <div className="detail-item">
                  <label>Full Name</label>
                  <p>{reportDetail.name}</p>
                </div>
                <div className="detail-item">
                  <label>Email Address</label>
                  <p>{reportDetail.email}</p>
                </div>
                <div className="detail-item">
                  <label>Company</label>
                  <p>{reportDetail.company || "N/A"}</p>
                </div>
                <div className="detail-item">
                  <label>Designation</label>
                  <p>{reportDetail.designation || "N/A"}</p>
                </div>
                <div className="detail-item">
                  <label>Phone Number</label>
                  <p>{reportDetail.contactNo}</p>
                </div>
                <div className="detail-item">
                  <label>Country</label>
                  <p>{reportDetail.country}</p>
                </div>
                <div className="detail-item w-100">
                  <label>Specific Requirement</label>
                  <p className="requirement-text">{reportDetail.requirement || "No specific requirements provided."}</p>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>

        <Col lg={6}>
          {/* Report/Meta Information Card */}
          <Card className="shadow-sm border-0 mb-4 bg-light">
            <Card.Body>
              <h6 className="text-uppercase text-muted fw-bold mb-3 small">Request Metadata</h6>
              <div className="mb-3">
                <label className="text-muted d-block small">Request Type</label>
                <span className="badge bg-info text-dark">{reportDetail.requestType}</span>
              </div>
              <div className="mb-3">
                <label className="text-muted d-block small">Date of Request</label>
                <span className="fw-semibold">{formatDate(reportDetail.createdAt)}</span>
              </div>
              <hr />
              <h6 className="text-uppercase text-muted fw-bold mb-3 small">Target Report</h6>
              <div className="mb-2">
                <label className="text-muted d-block small">Report ID</label>
                <code className="text-primary fw-bold">#{reportDetail.reportId}</code>
              </div>
              <div className="mb-2">
                <label className="text-muted d-block small">Report Title</label>
                <p className="small mb-1 fw-medium">{reportDetail.reportTitle}</p>
              </div>
              {reportDetail.reportSlug && (
                <div className="mt-3">
                  <Button
                    variant="link"
                    className="p-0 text-decoration-none small fw-bold"
                    href={`https://www.makdatainsights.com/reports/${reportDetail.reportSlug}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    View Report on Website &rarr;
                  </Button>
                </div>
              )}

            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  </>
  );
};

export default SampleRequestDetail;